//
// Stake Selection Container
//
// Popup for players to select stake

stakeSelectionPopup = {};
stakeSelectionPopup.popups = [];
stakeSelectionPopup.maxStakesSupported = 15;

stakeSelectionPopup.create = function () {
  var object = new PIXI.Container();
  stakeSelectionPopup.container = object;

  // Get all objects on the autoplay dialog
  object.dialog = {};
  object.dialog.callbacks = {};

  object.openDialog = stakeSelectionPopup.openDialog;
  object.selectLayout = stakeSelectionPopup.selectLayout;
  object.updateLayout = stakeSelectionPopup.updateLayout;
  object.forceClose = stakeSelectionPopup.forceClose;

  // Hide by default
  object.visible = false;

  stakeSelectionPopup.popups.push(object);

  return object;
};
stakeSelectionPopup.destroy = function (popup) {
  var index = stakeSelectionPopup.popups.indexOf(popup);
  if (index === -1) {
    console.log('Could not destroy stake selection popup as it could not be found');
    return;
  }

  stakeSelectionPopup.popups.splice(index, 1);
};

stakeSelectionPopup.initialise = function (json, object) {
  // Clickable background behind panel
  object.background = new PIXI.Graphics();
  object.addChild(object.background);

  object.background.beginFill(0, 0.0);
  object.background.drawRect(-10000, -10000, 20000, 20000);
  object.background.endFill();
  object.background.interactive = true;
  object.background.mousedown = object.background.touchstart = stakeSelectionPopup.onCancel;

  object.dialog.buttons = [];
  object.dialog.buttonsText = [];

  // Create background / title
  object.dialog.background = resourceManager.createObject('sprite', 'background', json.FQN, {
    fileName: json.backgroundFile,
  });
  var maxWidth = checkForDefined(json.maxWidth) ? json.maxWidth : object.dialog.background.width;
  resourceManager.createObject('text', 'title', json.FQN, {
    text: '',
    translationPhrase: json.translationPhrase,
    fontDefinition: json.titleFontDefinition,
    x: maxWidth / 2,
    y: 60,
    maxWidth: maxWidth,
  });

  // Create all buttons we will need
  for (var i = 0; i < stakeSelectionPopup.maxStakesSupported; i++) {
    var button = resourceManager.createObject('sprite', 'button' + i, json.FQN + ':background', {
      fileName: json.buttonFile,
    });
    button.stakeIndex = i;
    button.interactive = true;
    button.mousedown = button.touchstart = stakeSelectionPopup.onStakeButtonPressed;
    button.anchor.set(0.5);
    object.dialog.buttons.push(button);

    var buttonText = resourceManager.createObject('text', 'buttonText' + i, json.FQN + ':background' + ':button' + i, {
      text: json.buttonText,
      fontDefinition: json.buttonFontDefinition,
      x: 0,
      y: 0,
      maxWidth: 190,
    });
    if (checkForDefined(json.maxButtonWidth)) buttonText.maxWidth = json.maxButtonWidth;
    object.dialog.buttonsText.push(buttonText);
  }
};

stakeSelectionPopup.onCancel = function () {
  soundManager.play('stakeCancelled');
  stakeSelectionPopup.forceClose();
  stakeSelectionPopup.container.dialog.callbacks.cancelled();
};

stakeSelectionPopup.onStakeButtonPressed = function () {
  var popup = this.parent.parent;

  for (var i = 0; i < stakeSelectionPopup.maxStakesSupported; i++) {
    popup.dialog.buttons[i].interactive = false;
  }

  timerManager.addTimer(100, stakeSelectionPopup.fadeOutDialog, stakeSelectionPopup.fadeOutDialogComplete, popup);

  popup.dialog.selectedStakeIndex = this.stakeIndex;
};

stakeSelectionPopup.selectLayout = function (stakes) {
  this.dialog.numItems = stakes.length;
  this.dialog.stakes = stakes;

  if (this.dialog.numItems === 0) {
    console.error('Not stakes passed into stake selection popup');
    return;
  }

  if (this.dialog.numItems > stakeSelectionPopup.maxStakesSupported) {
    console.error('Stake selection popup only supports up to ' + stakeSelectionPopup.maxStakesSupported + ' items');
    return;
  }

  this.dialog.currentHeight = Math.floor((this.dialog.numItems - 1) / 3) + 1;
  this.dialog.currentWidth = this.dialog.numItems < 4 ? this.dialog.numItems : 3;
  if (this.dialog.numItems === 4) {
    this.dialog.currentWidth = 2;
  }

  this.updateLayout();
};

stakeSelectionPopup.updateAllLayouts = function () {
  for (var i = 0; i < stakeSelectionPopup.popups.length; i++) {
    stakeSelectionPopup.popups[i].updateLayout();
  }
};

stakeSelectionPopup.updateLayout = function () {
  if (!stakeSelectionPopup.isActive) {
    return;
  }

  var margin = 28 / resourceManager.selectedAssetResolution.scaleFactor;
  var buttonWidth = this.dialog.buttons[0].texture.width * resourceManager.selectedAssetResolution.scaleFactor;
  var fullWidth =
    (this.dialog.background.texture.width - margin * 2) * resourceManager.selectedAssetResolution.scaleFactor;

  // Layout buttons we are going to use
  var currentButtonIndex = 0;
  var itemsRemaining = this.dialog.numItems;
  var layoutString = '';
  for (var i = 0; i < this.dialog.currentHeight; i++) {
    var itemsInThisRow = Math.min(this.dialog.currentWidth, itemsRemaining);
    layoutString += itemsInThisRow.toString() + ',';

    var buttonSpace = (fullWidth - buttonWidth * 3) / 4;
    var buttonOffsetX = buttonSpace + buttonWidth;
    var buttonStartX =
      (this.dialog.background.texture.width / 2) * resourceManager.selectedAssetResolution.scaleFactor -
      (itemsInThisRow - 1) * (buttonOffsetX * 0.5);

    for (var j = 0; j < itemsInThisRow; j++) {
      var x = buttonStartX + j * buttonOffsetX;
      var y =
        ((800 - this.dialog.currentHeight * 156) / (this.dialog.currentHeight + 1)) * (i + 1) + i * 125 + 128 + 50;

      this.dialog.buttons[currentButtonIndex].visible = true;
      this.dialog.buttons[currentButtonIndex].position.set(x, y);
      this.dialog.buttonsText[currentButtonIndex].setText(
        MeterManager.formatText(this.dialog.stakes[currentButtonIndex])
      );
      this.dialog.buttonsText[currentButtonIndex].anchor.set(0.5);

      currentButtonIndex++;
    }

    itemsRemaining -= itemsInThisRow;
  }

  // Hide remaining buttons
  for (var i = this.dialog.numItems; i < stakeSelectionPopup.maxStakesSupported; i++) {
    this.dialog.buttons[i].visible = false;
  }
};

stakeSelectionPopup.fadeInDialog = function (progress, object) {
  object.alpha = progress;
};

stakeSelectionPopup.fadeInDialogCompete = function (object) {
  // Set all buttons to interactive
  for (var i = 0; i < stakeSelectionPopup.maxStakesSupported; i++) {
    object.dialog.buttons[i].interactive = true;
  }

  object.alpha = 1;
};

stakeSelectionPopup.fadeOutDialog = function (progress, object) {
  object.alpha = 1 - progress;
};

stakeSelectionPopup.fadeOutDialogComplete = function (object) {
  stakeSelectionPopup.forceClose();

  // Now we have left dialog, inform game of stake selected
  object.dialog.callbacks.stakeSelected(object.dialog.selectedStakeIndex);
};

stakeSelectionPopup.forceClose = function () {
  stakeSelectionPopup.container.visible = false;
  stakeSelectionPopup.container.alpha = 1;
  stakeSelectionPopup.isActive = false;
};

stakeSelectionPopup.openDialog = function (stakes, stakeSelectedCallback, cancelledCallback) {
  if (
    checkForUndefined(
      stakeSelectedCallback,
      'stake selected callback was not defined in stakeSelectionPopup.openDialog',
      true
    ) ||
    checkForUndefined(cancelledCallback, 'Cancel callback was not defined in stakeSelectionPopup.openDialog', true)
  ) {
    return;
  }

  // Fade in dialog
  this.visible = true;
  this.alpha = 0;
  timerManager.addTimer(100, stakeSelectionPopup.fadeInDialog, stakeSelectionPopup.fadeInDialogCompete, this);

  // Store callbacks
  this.dialog.callbacks.stakeSelected = stakeSelectedCallback;
  this.dialog.callbacks.cancelled = cancelledCallback;

  // Set up layout
  stakeSelectionPopup.isActive = true;
  this.selectLayout(stakes);
};

stakeSelectionPopup.getFileRequired = function (json) {
  return [json.backgroundFile, json.buttonFile];
};

Reflex.registerEventHandler('resize', stakeSelectionPopup.updateAllLayouts);
resourceManager.registerObjectType(
  'stakeSelection',
  stakeSelectionPopup.create,
  stakeSelectionPopup.initialise,
  stakeSelectionPopup.getFileRequired,
  stakeSelectionPopup.destroy
);
